<template>
  <div class="app-wrapper">
    <el-container>
      <!--header-->
      <el-header style="min-width: 1280px">
        <div class="header-left">
          <span class="toggle" @click="toggleChange">
            <i class="el-icon-s-fold"></i>
          </span>
          <span class="name">{{
            $store.state.eduWebConfig.eduWebConfigInfo.webName
          }}</span>
        </div>
        <!--顶部菜单-->
        <div>
          <top-menu @toggleChange="toggleChange"></top-menu>
        </div>
        <!--用户栏-->
        <div>
          <user-box></user-box>
        </div>
      </el-header>
      <el-main @click.native="mainClick">
        <div style="display: flex; flex-direction: column">
          <!--面包屑-->
          <div>
            <breadcrumb style="height: 30px; line-height: 30px"></breadcrumb>
          </div>
          <!--主面板-->
          <div>
            <router-view></router-view>
          </div>
          <!--footer-->
          <div class="main-footer">
            <p>
              <a href="https://beian.mps.gov.cn/#/query/webSearch?code=51010702042932" rel="noreferrer"
                target="_blank"><img style="height: 15px; margin-right: 6px; margin-bottom: -4px"
                  src="/static/images/备案图标.png">川公网安备51010702042932</a>
            </p>
            <p>
              <a target="_bank" href="https://beian.miit.gov.cn">蜀ICP备20012822号-4</a>
            </p>
            <p v-if="!$store.state.eduWebConfig.eduWebConfigInfo.scaleAlias">
              <a href="http://www.bluerhyme.net/" target="_bank">四川蓝韵心理咨询服务有限公司</a>
            </p>

            <p v-if="$store.state.eduWebConfig.eduWebConfigInfo.isQingHai">
              <a href="http://www.bluerhyme.net/" target="_bank">青海伟一蓝韵心理咨询服务有限公司</a>
            </p>

            <!-- <p v-else>
              <a href="http://www.bluerhyme.net/" target="_bank">四川心海蓝韵信息科技有限公司</a>
            </p> -->
          </div>
        </div>
      </el-main>
      <!--左侧菜单-->
      <div class="leftMenuContainer">
        <left-menu style="overflow: auto" :style="{ height: scrollerHeight }" @toggleChange="toggleChange"></left-menu>
      </div>
    </el-container>
  </div>
</template>

<script>
import leftMenu from "./components/LeftMenu";
import topMenu from "./components/TopMenu";
import userBox from "./components/UserBox";
import Breadcrumb from "@/components/Breadcrumb/index";

export default {
  data() {
    return {
      // 侧边菜单栏显示/隐藏
      isShow: false,
      // 消息条数
      news: 9,
      // 用户默认头像
      userIcon:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      // 用户名
      userName: "admin",
      scrollerHeight: window.innerHeight - 96 + "px",
    };
  },
  components: {
    leftMenu,
    topMenu,
    userBox,
    Breadcrumb,
  },
  mounted() {
    let self = this;
    window.onresize = () => {
      return (() => {
        self.scrollerHeight = window.innerHeight - 96 + "px";
      })();
    };
  },
  methods: {
    // 点击右侧内容区域隐藏左侧菜单栏
    mainClick() {
      if (this.isShow) {
        this.isShow = false;
        $(".leftMenuContainer").animate({ left: "-=250px" }, 600);
      }
    },
    // 切换菜单栏
    toggleChange() {
      if (this.isShow) {
        $(".leftMenuContainer").animate({ left: "-=250px" }, 600);
        this.isShow = false;
      } else {
        $(".leftMenuContainer").animate({ left: "+=250px" }, 600);
        this.isShow = true;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  background-color: rgba(249, 248, 253, 1);
  background-size: cover;

  .el-container {
    height: 100%;

    .el-header {
      height: 70px !important;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-shadow: 0px 5px 15px rgba(179, 198, 252, 1);
      color: white;
      background: linear-gradient(090deg, #000248, #1792c2);
      background-image: url("/static/images/header_bg.jpg");
      background-size: cover;

      .header-left {
        display: flex;
        align-items: center;
        justify-content: space-around;

        .toggle {
          cursor: pointer;

          .el-icon-s-fold {
            font-size: 30px;
          }
        }

        .name {
          margin-left: 15px;
          font-family: "微软雅黑 Regular", "微软雅黑";
          font-weight: 400;
          font-style: normal;
          font-size: 22px;
          color: #ffffff;
        }
      }
    }

    .el-main {
      height: 100%;
      padding: 0 20px;
      // padding: 10px 20px 10px 20px;
      box-sizing: border-box;

      .main-footer {
        height: 30px;
        text-align: center;
        margin-top: 5px;

        a {
          font-size: 13px;
          color: #999999;
          text-decoration: none;
          margin-top: 5px;
        }
      }
    }

    .leftMenuContainer {
      position: fixed;
      z-index: 9999;
      top: 70px;
      left: -250px;
      height: 100%;
      background-color: rgba(40, 49, 66, 1);
      box-shadow: 5px 8px 15px rgba(179, 198, 252, 1);
      padding-top: 15px;
      width: 240px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue